export default __webpack_public_path__ + "static/6818-d6a00d009d03cecabeaed0b1c20c100b.jpg";